












































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSformTable from '@/components/AMSformTable.vue';
import { allStaff } from '@/api/staff';
import Utils from '@/utils/utils';
import { comissionExport } from '@/api/report';
import { AppStore } from '@/store/modules/app';
import moment from 'moment';

@Component({
  components: {
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-formtable': AMSformTable
  }
})
export default class ComissionList extends Vue {
  /**面包屑 */
  breadItems = [
    {
      text: '报表管理',
      disabled: false,
      href: 'commision_list'
    },
    {
      text: '提成报表',
      disabled: true
    }
  ];
  //   接口请求地址
  api: string = '/api/Report/RechargeCommission';
  //搜索form
  form: any = {
    saleId: '',
    beautyAdvisorId: '',
    startTime: moment(
      moment()
        .subtract(1, 'months')
        .startOf('month')
        .format('YYYY-MM-DD')
    ).toISOString(),
    endTime: moment(
      moment()
        .subtract(1, 'months')
        .endOf('month')
        .format('YYYY-MM-DD')
    ).toISOString()
  };
  startTimeStr: string = moment()
    .subtract(1, 'months')
    .startOf('month')
    .format('YYYY-MM-DD');
  endTimeStr: string = moment()
    .subtract(1, 'months')
    .endOf('month')
    .format('YYYY-MM-DD');
  //   表头
  headers: any[] = [];
  /**销售 美导 */
  activeItems: any[] = [{ value: '', text: '全部' }];
  //开始时间 弹窗
  beginTime: boolean = false;
  //结束时间 弹窗
  endTime: boolean = false;
  /**当前时间 */
  currentTime: string = new Date().toISOString().substr(0, 10);
  /**列表数据 */
  datas: any[] = [];
  //列表合计
  statisticsDataRows: any[] = [];

  @Watch('startTimeStr', { immediate: true, deep: true })
  onStartTimeStrChange(newValue: string, oldValue: string) {
    this.form.startTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('endTimeStr', { immediate: true, deep: true })
  onEndTimeStrChange(newValue: string, oldValue: string) {
    this.form.endTime = newValue ? moment(newValue).toISOString() : '';
  }

  mounted() {
    this.getStaff();
  }

  formatCurrencyPrice(v: any) {
    return Utils.formatCurrencyPrice(v);
  }

  getPermission(name: string) {
    return Utils.isPermission(name);
  }

  //点击了销售的叉叉按钮
  onSaleClear() {
    setTimeout(() => {
      this.form.saleId = '';
    }, 1);
  }

  //点击了美导的叉叉按钮
  onGuiderClear() {
    setTimeout(() => {
      this.form.beautyAdvisorId = '';
    }, 1);
  }

  /**获取销售 美导*/
  getStaff() {
    allStaff({ isActive: true, permissionCheck: true }).then((data: any) => {
      this.activeItems = [{ value: '', text: '全部' }].concat(
        data.items.map((i: any) => {
          i.value = i.id;
          i.text = i.name;
          return i;
        })
      );
    });
  }

  //搜索清空
  handleInitForm() {
    this.form = {
      saleId: '',
      beautyAdvisorId: '',
      startTime: moment(
        moment()
          .subtract(1, 'months')
          .startOf('month')
          .format('YYYY-MM-DD')
      ).toISOString(),
      endTime: moment(
        moment()
          .subtract(1, 'months')
          .endOf('month')
          .format('YYYY-MM-DD')
      ).toISOString()
    };
    this.startTimeStr = moment()
      .subtract(1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD');
    this.endTimeStr = moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('YYYY-MM-DD');
  }

  //表格传出的数据
  handleGetOtherData(obj: any) {
    const data = obj.items;
    if (data) {
      const columns = data.columns;
      if (columns && Object.keys(columns).length > 0) {
        let h: any[] = [];
        for (const key in columns) {
          const k = key;
          const v = columns[k];
          h.push({
            text: v,
            value: k,
            align: 'left'
          });
        }
        this.headers = h;
      }

      const dataRows = data.dataRows.items;
      if (columns && dataRows.length > 0) {
        const row = dataRows[0];
        this.headers.forEach(element => {
          const k = element.value;
          element.isCurrency = typeof row[k] === 'number';
          element.align = typeof row[k] === 'number' ? 'right' : 'left';
          element.isFormatDate = isNaN(row[k]) && !isNaN(Date.parse(row[k]));
          if (element.isFormatDate === true) {
            element.width = '150';
          }
        });
        this.datas = dataRows;
      }

      const reportName = data.reportName;

      const statisticsDataRows = data.statisticsDataRows;
      this.statisticsDataRows = statisticsDataRows;
    }
    console.log(obj, '获取到的数据');
  }

  //导出
  handleExport() {
    const params = { ...this.form, exportExcel: true };
    comissionExport(params)
      .then(response => {
        AppStore.ShowSuccess('下载成功');
      })
      .catch(error => {
        AppStore.ShowError('下载失败');
      });
  }
}
